import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdydytg5fm: FaireProductEntity = {
  token: "p_gdydytg5fm",
  type: "product",
  name: "BIODANCE Refreshing Sea Kelp Real Deep Face Sheet Mask",
  brandName: "Best Beauty Group",
  imageUrl:
    "https://cdn.faire.com/fastly/ea408182c2641428aea3c4978f95b7a1697c00d4a9583a61dd3bf14ea463bbc3.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7ea178eb65d7cd62834fdd2d335089d76e5db43c7a4ef31743b6e855c41a2294.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
